let tick = false

export default (revealLs) => {

    setInterval(function() {
        if(tick){
            tick = false;
            revealLs.forEach(reveal => {
                if(window.navigator.userAgent.includes("MSIE") || window.navigator.userAgent.includes("Trident")){
                    reveal.classList.add('triggered-reveal');
                    return
                }
                let stepScroll = reveal.offsetTop - (window.innerHeight * 2 / 3);
                if (window.scrollY > stepScroll){
                    reveal.classList.add('triggered-reveal');
                }
            });
        }
    }, 100);


    document.addEventListener('scroll', function (evt) {
        tick = true;
    }, {
        passive: true
    })
}